module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1r4r8n-cfbd56775fbf9005fd64eb0016d85f52.svg";